export default __webpack_public_path__ + "static/media/amex.be30ef95.svg";